function simPROMaps(options) {
  var self = this;
  this.setValues = function (options) {
    this.provider = options.provider ? options.provider : 'none';
    this.key = options.key;
    this.supProvider = options.supProvider ? options.supProvider : 'none';
    this.supKey = options.supKey;
    this.isInitialized = false;
  };

  this.createMap = function (mapContainerID, mapOptions) {
    if (this.isInitialized) return;

    mapOptions["center"] = mapOptions["center"] ? mapOptions["center"] : [0,0];
    mapOptions["zoom"] = mapOptions["zoom"] ? mapOptions["zoom"] : 18;

    var streets = L.tileLayer.Unwired({
      key: this.key,
//      attribution: 'simTrac &copy; <a href="https://www.simpro.co/">simPRO</a>',
      maxZoom: 18,
      scheme: "streets"
    });

    var map = L.map(mapContainerID, { layers: [streets] });
    map.on('load', function(){
      self.isInitialized = true;
    });

    if (mapOptions['enableSatelliteView']) {
      var mapboxUrl =
          "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=" + this.supKey;
      var mapboxAttribution =
          ['Map data &copy; <a target="osm_mapbox" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> Contributors', ' Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'];

      var satellite = L.tileLayer(mapboxUrl, {
        id: "mapbox.satellite",
        attribution: mapboxAttribution
      });

      L.control.layers({
        "Map": streets,
        "Satellite": satellite
      },null,{"position": 'topleft'}).addTo(map);
      map.addControl(new L.Control.Fullscreen({ position: 'topright' }));
    }
    map.zoomControl.setPosition('bottomright');
    map.setView(mapOptions["center"], mapOptions["zoom"]);
    this.map = map;
    return map;
  };

  this.createCircle = function (latlon, options) {
    let circle = new L.Circle(latlon, options);

    if (this.map) {
      circle.addTo(this.map);
    }
    return circle;
  };

  this.createMarker = function (latlon, icon, infoWindow, label, options) {
    let marker = new L.Marker(
      latlon,
      {
        icon: icon,
      }
    );
    if (this.map) {
      marker.addTo(this.map);
    }

    if (infoWindow) {
      infoWindow.setLatLng(latlon);
      marker.on('click', function(){ infoWindow.openOn(self.map)});
    }
    return marker;
  };

  this.createBounds = function() {
    return new L.latLngBounds();
  };

  this.createIconFromUrl = function (url, size, anchor) {
    if (!size) {
      size = [28,37];
    }
    if (!anchor) {
      anchor = [size[0]/2, size[1]];
    }
    return L.icon({
      iconUrl: url,
      iconSize: size,
      iconAnchor: anchor
    });
  };

  this.fitBounds = function(bounds) {
    this.map.fitBounds(bounds);
  };

  this.extend = function(bound) {
    this.map.bounds.extend(bound);
  };

  this.setValues(options);
}
